import React, { useEffect } from 'react';
import FormSelect from 'Shared/components/FormComponents/FormSelect';
import { Field, useField } from 'react-final-form';

import { useToggle, useFieldValue } from 'Shared/utils/hooks';
import FormVideoRecorder from 'Shared/components/FormComponents/FormVideoRecorder';
import FormGifPicker from 'Shared/components/FormComponents/FormGifPicker';
import FormTextarea from 'Shared/components/FormComponents/FormTextarea';
import FormIf from 'Shared/components/FormComponents/FormIf/FormIf';
import { FormIfOperator } from 'Shared/constants/types';
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';

export default function FormFields() {
  const [showRecorder, toggleRecorder] = useToggle(false);
  const workspaces = useFieldValue('workspaces');
  const currentWorkspace = useFieldValue('currentWorkspace');
  const workspacesOptions = workspaces.map(({ uuid, fullName }) => ({ value: uuid, label: fullName }));

  const {
    input: { onChange: onCurrentWorkspaceChange },
  } = useField('kudos.workspaceUuid');

  useEffect(() => {
    onCurrentWorkspaceChange(currentWorkspace);
  }, [currentWorkspace]);

  const showInputs = !!currentWorkspace;

  return (
    <div className="onboarding-kudos-fields scrollbar">
      <div className="d-flex mt-4">
        <p className="onboarding-workspaces-label  mb-0 mr-1">Choose one person to give Kudos to now</p> (you can give
        more later)
      </div>
      <Field hidden initialValue={currentWorkspace} name="kudos.workspaceUuid" component="input" />
      <Field
        name="currentWorkspace"
        className="mt-2 onboarding-kudos-field"
        options={workspacesOptions}
        placeholder="Select person"
        component={FormSelect}
      />
      {showInputs && (
        <>
          <div className="d-flex justify-content-between align-items-center mt-4 mb-1">
            <p className="onboarding-workspaces-label  mb-0 mr-1">Say something nice</p>
            <WpButton variant="tertiary" onClick={toggleRecorder}>
              <WpIcon name="video-plus" />
              Record a Video
            </WpButton>
          </div>
          <Field
            name="kudos.likeThatVideo"
            className="mt-2"
            showRecorder={showRecorder}
            toggleRecorder={toggleRecorder}
            showRecordButton={false}
            component={FormVideoRecorder}
          />
          <FormIf fieldName="kudos.likeThatVideo" operator={FormIfOperator.include} value={[null, '', undefined]}>
            <Field
              name="kudos.likeThatText"
              component={FormTextarea}
              placeholder="Type your thoughtful feedback here"
              fastBlur
            />
            <Field name="searchStr">
              {({ input: { value, onChange } }) => (
                <>
                  <div className="d-flex justify-content-between mt-4 mb-1">
                    <p className="onboarding-workspaces-label mb-0 mr-1">Add a gif</p>
                    <div className="d-flex align-items-center">
                      <span className="text-muted mr-2">
                        <WpIcon name="search" />
                      </span>
                      <input
                        className="onboarding-kudos-search-input"
                        placeholder="Search gifs"
                        type="text"
                        value={value}
                        onChange={onChange}
                      />
                    </div>
                  </div>

                  <Field
                    name="kudos.gifUrl"
                    searchInput={false}
                    searchStr={value}
                    clearOnSearch
                    component={FormGifPicker}
                  />
                </>
              )}
            </Field>
          </FormIf>
        </>
      )}
    </div>
  );
}
